import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { DomSanitizer } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";

import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";

import { SuperAdminService } from "src/app/super-admin.service";
import { ImagePreviewComponent } from "../image-preview/image-preview.component";
import { map, startWith } from "rxjs/operators";

@Component({
  selector: "app-tracker-module",
  templateUrl: "./tracker-module.component.html",
  styleUrls: ["./tracker-module.component.css"],
})
export class TrackerModuleComponent implements OnInit {
  today = new Date().toISOString().split("T")[0];
  yesterday = new Date(Date.now() - 86400000).toISOString().split("T")[0];
  vehicleRatees: any = 0;
  materials = [];
  material: any;
  rateChart: any;

  paramId: any;
  isMultiple = true;

  imageSrc: any;
  imageSrcpodback: any;

  companyList = [];

  companyAddress: any = [{}];
  supervisorIDs: any;
  permitFromVehicle;
  multipletrips = [];
  multipleTrips = [];
  tripIDS = [];
  dropTripID = [];
  list = [];
  val = "";
  shown = false;
  @Input("size") size;
  selected = "Search";
  @ViewChild("searchfield", { static: false }) searchfield: ElementRef;
  onChange: any = () => {};
  check = false;
  dropdownSettings: {
    singleSelection: boolean;
    searchPlaceholderText: string;
    idField: string;
    textField: string;
    allowSearchFilter: boolean;
    unSelectAllText: string;
  };
  uniqueRes: any = [];
  receipt: any[];
  tripId: any;
  filterdOptions = [];
  vehicles = [];
  DriverNumber;
  vehiclesNumber = [];
  vehicleType;
  vehicleRoadPermit;
  InvoiceDetails: MatTableDataSource<any> = new MatTableDataSource([]);
  vehicletypes = [];
  vehiclePermitNum = [];
  vehicleTypesNames = [];
  vehiclePermit = [];
  filesToUpload: Array<File> = [];
  Tollfiles: Array<File> = [];
  TollfilesString = [];
  loadingSlips: Array<File> = [];
  loadingSlipsBack: Array<File> = [];
  loadingSlipsString = [];
  loadingSlipsBackString = [];
  clientList = [];
  actualbalance: any = 0;
  updownkm: any = 0;
  totalhour = 0;
  DriverList = [];
  DriverLists = [];
  // DriverNumber;
  isSupervisor = false;

  displayedColumns = [
    "noOfArticle",
    "invoiceNo",
    "customerName",
    "invoiceValue",
    "weight",
    "pod",
  ];
  options: string[] = ["One", "Two", "Three"];
  filteredVehicleTypes: Observable<string[]>;
  filteredVehicleRoadPermit: Observable<string[]>;
  filteredConsignorName: Observable<string[]>;
  filteredVehicleNo: Observable<string[]>;
  filteredDriverName: Observable<string[]>;
  filteredDriverNumber: Observable<string[]>;
  addNewLR = new FormGroup({
    supervisorname: new FormControl(""),
    clientList: new FormControl("", Validators.compose([Validators.required])),
    VehicleNo: new FormControl("", Validators.compose([Validators.required])),
    vehicleType: new FormControl(""),
    from: new FormControl(
      "",
      Validators.compose([
        Validators.required,
        Validators.pattern(/^\S+|^\s+\S+/),
      ])
    ),
    to: new FormControl(
      "",
      Validators.compose([
        Validators.required,
        Validators.pattern(/^\S+|^\s+\S+/),
      ])
    ),
    POD: new FormControl(""),
    fixAdhoc: new FormControl("", Validators.required),
    fixedKM: new FormControl("", Validators.pattern("^[0-9]*$")),
    extraKMCost: new FormControl("", Validators.pattern("^[0-9]*$")),
    variableCostHr: new FormControl("", Validators.pattern("^[0-9]*$")),
    fixedPayment: new FormControl("", Validators.pattern("^[0-9]*$")),
    fixedPaymentMonth: new FormControl("", Validators.pattern("^[0-9]*$")),


    customerName: new FormControl("", Validators.required),
    InvoiceNo: new FormControl("", Validators.required),
    InvoiceValue: new FormControl("", Validators.required),
    Weight: new FormControl("", Validators.required),
    NoofArticle: new FormControl("", Validators.required),
    startmeterReading: new FormControl(
      "",
      Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])
    ),
    endmeterReading: new FormControl(
      "",
      Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])
    ),
    tripSDate: new FormControl("", Validators.required),
    tripEDate: new FormControl(""),
    outtime: new FormControl("", Validators.required),
    INtime: new FormControl(""),
    noofTools: new FormControl("", Validators.pattern("^[0-9]*$")),
    tooltaxPaid: new FormControl("", Validators.pattern("^[0-9]*$")),
    labourPaid: new FormControl("", Validators.pattern("^[0-9]*$")),
    otherPayment: new FormControl("", Validators.pattern("^[0-9]*$")),
    updownkm: new FormControl(""),
    totalhour: new FormControl(""),
    extrahour: new FormControl("", Validators.pattern("^[0-9]*$")),
    DLY: new FormControl(""),
    orderId: new FormControl(""),

    advance: new FormControl(
      "",
      Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])
    ),
    balance: new FormControl(""),
    balancePaid: new FormControl(
      "",
      Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])
    ),
    vehicleRate: new FormControl(
      "",
      Validators.compose([Validators.required, Validators.pattern("^[0-9]*$")])
    ),
    tripIdGeneration: new FormControl("False", Validators.required),
    date: new FormControl("", []),
    TDS: new FormControl("", Validators.pattern("^[0-9]*$")),
    munsipalAmount: new FormControl("", Validators.pattern("^[0-9]*$")),
    finalAmount: new FormControl("", Validators.pattern("^[0-9]*$")),

    otherPaymentDescription: new FormControl(""),
  });
  docURL: any;
  podURL: any;
  podParticularURL: any;

  @ViewChild("showDoc") showDoc: ElementRef;
  @ViewChild("showPOD") showPOD: ElementRef;
  @ViewChild("showParticularPOD") showParticularPOD: ElementRef;
  superVisor: any;
  rate: any;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer
  ) {
    this.activatedRoute.params.subscribe((param) => {
      this.paramId = param.id;
    });

    if (this.paramId == "single") {
      this.isMultiple = false;
      console.log(this.isMultiple);
    }
  }
  count_user_click = 0;
  decValue = 0;
  submitLRClicked = false;
  userSessionData: any;
  get ff() {
    return this.addNewLR.controls;
  }
  ngOnInit(): void {
    const session = sessionStorage.getItem("userSession");
    this.userSessionData = session ? JSON.parse(session) : null;

    if (this.userSessionData?.user_role_id?.[0] == 2) {
      this.isSupervisor = true;
    }

    if (this.isSupervisor) {
      this.addNewLR.get("date").setValidators([Validators.required]);
      this.addNewLR.get("date").updateValueAndValidity();
    }
    this.getVehicleType();
    this.getClientList();
    this.getSuperVisorName();
    this.getLR();
    this.getTripIDs();
    this.getVehicleDetails();
  }

  getClientList() {
    this.superAdminService.getClientList().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.clientList = rawdata;
          this.companyList = this.clientList.map((x) => x.clientName);
          this.userSessionData = JSON.parse(
            sessionStorage.getItem("userSession")
          );
          let userroleid = this.userSessionData.user_role_id[0];
          if (userroleid != 1) {
            let clients = this.userSessionData.clientList;
            this.clientList = clients.map((id) => {
              return this.clientList.filter((item) => item._id == id)[0];
            });
          }
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => {}
    );
  }

  getVehicleType() {
    this.superAdminService.getVehicleType().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status === true) {
          this.vehicletypes = res.data;
          this.vehicleTypesNames = this.vehicletypes.map(
            (item) => item.vehicletype_name
          );

          this.filteredVehicleTypes = this.ff.vehicleType.valueChanges.pipe(
            startWith(""),
            map((value: string) => this._filterVehicleType(value || ""))
          );
        } else {
          if (res.status === 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private _filterVehicleType(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.vehicleTypesNames.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  getvehiclePermit() {
    // console.log("ddddd")
    var NO = this.permitFromVehicle;
    this.superAdminService
      .getVehiclePermit(NO)
      .subscribe((res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.vehiclePermitNum = rawdata;
          this.vehiclePermitNum.forEach((item) => {
            this.vehiclePermit.push(item.permitNumber);
          });
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      });
  }

  private _filterVehiclePermit(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.vehiclePermitNum.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  getVehicleDetails() {
    this.superAdminService.getvehicles().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          this.vehicles = res.data;
          this.vehicles.forEach((item) => {
            this.vehiclesNumber.push(item.vehicle_no);
          });
          this.filteredVehicleNo = this.ff.VehicleNo.valueChanges.pipe(
            startWith(""),
            map((value) => this._filterVehicleNo(value || ""))
          );
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            this.addNewLR.patchValue({
              // driverMobile:  this.DriverNumber
            });
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => {}
    );
  }
  private _filterVehicleNo(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.vehiclesNumber.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }
  fileChangeEventtollAttachment(fileInput: any) {
    for (var i = 0; i < fileInput.target.files.length; i++) {
      this.Tollfiles.push(fileInput.target.files[i]);
    }
  }
  fileChangeEventloadingSlipAttchment(fileInput: any) {
    this.loadingSlips = [];
    for (var i = 0; i < fileInput.target.files.length; i++) {
      this.loadingSlips.push(fileInput.target.files[i]);
    }
  }

  readURL(event: any, pod: any): void {
    if (pod === "front") {
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];

        const reader = new FileReader();
        reader.onload = (e) => (this.imageSrc = reader.result);

        reader.readAsDataURL(file);
      }
    } else {
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];

        const reader = new FileReader();
        reader.onload = (e) => (this.imageSrcpodback = reader.result);

        reader.readAsDataURL(file);
      }
    }
  }
  clearpodfront(pod: any) {
    if (pod === "front") {
      this.imageSrc = "";
    } else {
      this.imageSrcpodback = "";
    }
  }

  fileChangeEventloadingSlipBackAttchment(fileInput: any) {
    this.loadingSlipsBack = [];
    for (var i = 0; i < fileInput.target.files.length; i++) {
      this.loadingSlipsBack.push(fileInput.target.files[i]);
    }
  }

  addTollFiles() {
    const formData = new FormData();

    for (let i = 0; i < this.Tollfiles.length; i++) {
      formData.append("Tollfiles[]", this.Tollfiles[i]);
    }

    this.superAdminService.addTollFiles(formData).subscribe(
      (res: {
        rawdata: any;
        status: any;
        message: any;
        authorization: any;
        code: any;
      }) => {
        if (res.status == true) {
          this.toastr.success(res.message);
          this.TollfilesString = res.rawdata;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      (error) => {}
    );
  }

  addloadingSlips() {
    this.spinner.show();
    const formData = new FormData();
    for (let i = 0; i < this.loadingSlips.length; i++) {
      formData.append("loadingSlips[]", this.loadingSlips[i]);
    }
    this.superAdminService.addloadingSlips(formData).subscribe(
      (res: {
        rawdata: any;
        status: any;
        message: any;
        authorization: any;
        code: any;
      }) => {
        if (res.status == true) {
          this.toastr.success(res.message);
          this.loadingSlipsString = res.rawdata;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  addloadingSlipsBack() {
    this.spinner.show();
    const formData = new FormData();
    for (let i = 0; i < this.loadingSlipsBack.length; i++) {
      formData.append("loadingSlipsback[]", this.loadingSlipsBack[i]);
    }
    this.superAdminService.addloadingSlipsBack(formData).subscribe(
      (res: {
        rawdata: any;
        status: any;
        message: any;
        authorization: any;
        code: any;
      }) => {
        if (res.status == true) {
          this.toastr.success(res.message);
          this.loadingSlipsBackString = res.rawdata;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }
  fileChangeEventAttachment(fileInput: any) {
    this.filesToUpload.push(fileInput.target.files[0]);
  }
  onFocusOutEvent(event: any) {
    this.actualbalance =
      parseInt(this.addNewLR.get("vehicleRate").value) -
      parseInt(this.addNewLR.get("advance").value) -
      parseInt(event.target.value);
    this.addNewLR.patchValue({
      balance: this.actualbalance,
    });
  }
  onFocusOutendmeterReading(event: any) {
    this.updownkm =
      parseInt(event.target.value) -
      parseInt(this.addNewLR.get("startmeterReading").value);
    this.addNewLR.patchValue({
      updownkm: this.updownkm,
    });
  }
  getVehicleTypeFromNumber(event: any) {
    this.multipleTrips = [];
    this.multipletrips = [];

    const selectedVehicleNo = event.option.value;

    // Get vehicle type
    const vehicle = this.vehicles.find(
      (v) => v.vehicle_no === selectedVehicleNo
    );
    this.vehicleType = vehicle ? vehicle.type : "";
    console.log("vehicle", vehicle);
    // Get trips for this vehicle
    this.multipletrips = this.tripIDS
      .filter((trip) => trip.vehicle_no === selectedVehicleNo)
      .map((trip) => trip.TripID);

    // Remove duplicates
    this.multipletrips = Array.from(new Set(this.multipletrips));

    // Merge into multipleTrips
    this.multipleTrips = [...this.multipleTrips, ...this.multipletrips];

    // Patch form
    this.addNewLR.patchValue({
      vehicleType: this.vehicleType,
    });
  }

  onFocusOuttripEDate(event: any) {
    let outtime = this.addNewLR.get("outtime").value;
    let INtime = this.addNewLR.get("INtime").value;
    let sdate = this.addNewLR.get("tripSDate").value;
    let edate = this.addNewLR.get("tripEDate").value;
    let sd1 = sdate + " " + outtime + ":00";
    let date1 = new Date(sd1);
    let sd2 = edate + " " + INtime + ":00";
    let date2 = new Date(sd2);
    var diff = (date2.getTime() - date1.getTime()) / 1000;
    diff /= 60 * 60;
    let ht: any = Math.abs(Math.round(diff));

    this.addNewLR.patchValue({
      totalhour: ht.toString(),
    });
  }

  getSuperVisorName() {
    this.superAdminService.getSuperVisorName().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.superVisor = rawdata;
          //this.dtOptions.data = this.users;
        } else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
          }
        }
      },
      (error) => {}
    );
  }
  addInvoiceDetail() {
    var f = {
      id: "inv" + this.count_user_click,
      InvoiceNo: document.getElementById("InvoiceNoctrl")["value"],
      InvoiceValue: document.getElementById("InvoiceValuectrl")["value"],
      NoofArticle: document.getElementById("NoofArticlectrl")["value"],
      Weight: document.getElementById("Weightctrl")["value"],
      customerName: document.getElementById("customerNamectrl")["value"],
      POD: document.getElementById("PODctrl")["value"],
    };
    if (
      document.getElementById("InvoiceNoctrl")["value"] != "" &&
      document.getElementById("InvoiceValuectrl")["value"] != "" &&
      document.getElementById("NoofArticlectrl")["value"] != "" &&
      document.getElementById("Weightctrl")["value"] != "" &&
      document.getElementById("customerNamectrl")["value"] != ""
    ) {
      this.count_user_click += 1;
      let temp = this.InvoiceDetails.filteredData;
      temp.push(f);
      this.InvoiceDetails = new MatTableDataSource(temp);

      this.decValue += parseInt(
        document.getElementById("InvoiceValuectrl")["value"]
      );
      this.addNewLR.patchValue({
        // DeclaredValue: this.decValue
      });

      document.getElementById("InvoiceNoctrl")["value"] = "";
      document.getElementById("InvoiceValuectrl")["value"] = "";
      document.getElementById("NoofArticlectrl")["value"] = "";
      document.getElementById("Weightctrl")["value"] = "";
      document.getElementById("customerNamectrl")["value"] = "";
      document.getElementById("PODctrl")["value"] = "";
      this.removevalidatorcss("InvoiceNoctrl");
      this.removevalidatorcss("InvoiceValuectrl");
      this.removevalidatorcss("NoofArticlectrl");
      this.removevalidatorcss("Weightctrl");
      this.removevalidatorcss("customerNamectrl");
      this.removevalidatorcss("PODctrl");
    } else {
      if (this.addNewLR.get("InvoiceNo").invalid) {
        this.addvalidatorcss("InvoiceNoctrl");
      } else {
        this.removevalidatorcss("InvoiceNoctrl");
      }
      if (this.addNewLR.get("InvoiceValue").invalid) {
        this.addvalidatorcss("InvoiceValuectrl");
      } else {
        this.removevalidatorcss("InvoiceValuectrl");
      }
      if (this.addNewLR.get("NoofArticle").invalid) {
        this.addvalidatorcss("NoofArticlectrl");
      } else {
        this.removevalidatorcss("NoofArticlectrl");
      }
      if (this.addNewLR.get("Weight").invalid) {
        this.addvalidatorcss("Weightctrl");
      } else {
        this.removevalidatorcss("Weightctrl");
      }
      if (this.addNewLR.get("customerName").invalid) {
        this.addvalidatorcss("customerNamectrl");
      } else {
        this.removevalidatorcss("customerNamectrl");
      }
    }
  }
  addNewTrackerSubmit() {
    this.addNewLR.markAllAsTouched();
    this.submitLRClicked = true;

    if (!this.addNewLR.valid) {
      Object.keys(this.addNewLR.controls).forEach((key) => {
        if (this.addNewLR.get(key).invalid) this.addvalidatorcss(key + "ctrl");
        else this.removevalidatorcss(key + "ctrl");
      });
      return;
    }

    this.spinner.show();

    const storedData = JSON.parse(sessionStorage.getItem("userSession"));
    const supervisorIDs =
      storedData.user_role_id[0] == 1
        ? this.addNewLR.get("supervisorname").value
        : storedData._id;

    const form = {
      type: "Tracker",
      InvoiceNo: this.InvoiceDetails.filteredData,
      date: this.addNewLR.get("date").value,
      TripID: this.addNewLR.get("tripIdGeneration").value,
      VehicleNo: this.addNewLR.get("VehicleNo").value,
      vehicleType: this.addNewLR.get("vehicleType").value,
      from: this.addNewLR.get("from").value,
      to: this.addNewLR.get("to").value,
      fixAdhoc: this.addNewLR.get("fixAdhoc").value,
      fixedKM: this.addNewLR.get("fixedKM").value,
      extraKMCost: this.addNewLR.get("extraKMCost").value,
      variableCostHr: this.addNewLR.get("variableCostHr").value,
      fixedPayment: this.addNewLR.get("fixedPayment").value,
      fixedPaymentMonth: this.addNewLR.get("fixedPaymentMonth").value,
      supervisorId: supervisorIDs,
      clientList: this.addNewLR.get("clientList").value,

      startmeterReading: this.addNewLR.get("startmeterReading").value,
      endmeterReading: this.addNewLR.get("endmeterReading").value,
      tripSDate: this.addNewLR.get("tripSDate").value,
      tripEDate: this.addNewLR.get("tripEDate").value,
      INtime: this.addNewLR.get("INtime").value,
      outtime: this.addNewLR.get("outtime").value,
      noofTools: this.addNewLR.get("noofTools").value,
      tooltaxPaid: this.addNewLR.get("tooltaxPaid").value,
      updownkm: this.addNewLR.get("updownkm").value,
      totalhour: this.addNewLR.get("totalhour").value,
      extrahour: this.addNewLR.get("extrahour").value,
      advance: this.addNewLR.get("advance").value,
      balance: this.addNewLR.get("balance").value,
      balancePaid: this.addNewLR.get("balancePaid").value,
      vehicleRate: this.addNewLR.get("vehicleRate").value,
      otherPayment: this.addNewLR.get("otherPayment").value,
      otherPaymentDescription: this.addNewLR.get("otherPaymentDescription")
        .value,

      TDS: this.addNewLR.get("TDS").value,
      munsipalAmount: this.addNewLR.get("munsipalAmount").value,
      finalAmount: this.addNewLR.get("finalAmount").value,

      DLY: this.addNewLR.get("DLY").value,
      orderId: this.addNewLR.get("orderId").value,
    };

    const formData = new FormData();
    for (let i = 0; i < this.filesToUpload.length; i++) {
      formData.append("uploads[]", this.filesToUpload[i]);
    }

    formData.append("myFormData", JSON.stringify(form));


    this.superAdminService.createTracker(formData).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status === true) {
          this.toastr.success(res.message);
          this.router.navigate(["/superAdmin/lrmanagement/view-tracker"]);
        } else {
          if (res.status === 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else if (res.status === false) {
            this.toastr.error(res.message);
            if (res.data != null) {
              alert(`POD is not available with ${res.data}`);
            }
          } else {
            this.toastr.success(res.message);
          }
        }
      },
      error: (err) => {
        console.error("❌ Tracker creation failed:", err);
        this.spinner.hide();
        this.toastr.error("Something went wrong while creating tracker.");
      },
    });
  }

  resetForm() {
    this.addNewLR.reset();
    this.submitLRClicked = false;

    this.removevalidatorcss("generationIDctrl");

    this.removevalidatorcss("VehicleNoctrl");
    this.removevalidatorcss("vehicleTypectrl");
    this.removevalidatorcss("fromctrl");
    this.removevalidatorcss("toctrl");

    this.removevalidatorcss("datectrl");
    this.removevalidatorcss("fixAdhocctrl");
    this.removevalidatorcss("fixedKMctrl");
    this.removevalidatorcss("extraKMCostctrl");
    this.removevalidatorcss("variableCostHrctrl");
    this.removevalidatorcss("fixedPaymentctrl");
    this.removevalidatorcss("fixedPaymentMonthctrl");
    this.removevalidatorcss("quantityctrl");
    this.removevalidatorcss("balancectrl");

    //this.removevalidatorcss("statusctrl");
    this.removevalidatorcss("Frieghtctrl");

    // Information For office use only
    this.removevalidatorcss("startmeterReadingctrl");
    this.removevalidatorcss("endmeterReadingctrl");
    this.removevalidatorcss("tripSDatectrl");
    this.removevalidatorcss("tripEDatectrl");
    this.removevalidatorcss("outtimectrl");
    this.removevalidatorcss("INtimectrl");
    this.removevalidatorcss("noofToolsctrl");
    this.removevalidatorcss("tooltaxPaidctrl");
    this.removevalidatorcss("DLY");
    this.removevalidatorcss("orderId");


    this.removevalidatorcss("otherPaymentctrl");
    this.removevalidatorcss("updownkmctrl");
    this.removevalidatorcss("totalhourctrl");
    this.removevalidatorcss("extrahourctrl");

    this.removevalidatorcss("advancectrl");
    this.removevalidatorcss("balancectrl");
    this.removevalidatorcss("balancePaidctrl");

    this.removevalidatorcss("vehicleRatectrl");
  }
  addvalidatorcss(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.classList.add("validatorcss");
    }
  }

  removevalidatorcss(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.classList.remove("validatorcss");
    }
  }

  onKeyClientName(event: any) {
    if (this.addNewLR.get("clientList").invalid) {
      this.addvalidatorcss("clientListctrl");
    } else {
      this.removevalidatorcss("clientListctrl");
    }
  }
  onKeyConsigneeName(event: any) {
    if (this.addNewLR.get("ConsigneeName").invalid) {
      this.addvalidatorcss("ConsigneeNamectrl");
    } else {
      this.removevalidatorcss("ConsigneeNamectrl");
    }
  }
  onKeyConsigneeAddress(event: any) {
    if (this.addNewLR.get("ConsigneeAddress").invalid) {
      this.addvalidatorcss("ConsigneeAddressctrl");
    } else {
      this.removevalidatorcss("ConsigneeAddressctrl");
    }
  }
  onKeyConsignorName(event: any) {
    if (this.addNewLR.get("ConsignorName").invalid) {
      this.addvalidatorcss("ConsignorNamectrl");
    } else {
      this.removevalidatorcss("ConsignorNamectrl");
    }
  }
  onKeyConsignorAddress(event: any) {
    if (this.addNewLR.get("ConsignorAddress").invalid) {
      this.addvalidatorcss("ConsignorAddressctrl");
    } else {
      this.removevalidatorcss("ConsignorAddressctrl");
    }
  }
  onKeyVehicleNo(event: any) {
    if (this.addNewLR.get("VehicleNo").invalid) {
      this.addvalidatorcss("VehicleNoctrl");
    } else {
      this.removevalidatorcss("VehicleNoctrl");
    }
  }
  onKeyVehicleType(event: any) {
    if (this.addNewLR.get("vehicleType").invalid) {
      this.addvalidatorcss("vehicleTypectrl");
    } else {
      this.removevalidatorcss("vehicleTypectrl");
    }
  }
  onKeyFrom(event: any) {
    if (this.addNewLR.get("from").invalid) {
      this.addvalidatorcss("fromctrl");
    } else {
      this.removevalidatorcss("fromctrl");
    }
  }
  onKeyTo(event: any) {
    if (this.addNewLR.get("to").invalid) {
      this.addvalidatorcss("toctrl");
    } else {
      this.removevalidatorcss("toctrl");
    }
  }
  onKeyGSTIN(event: any) {
    if (this.addNewLR.get("GSTIN").invalid) {
      this.addvalidatorcss("GSTINctrl");
    } else {
      this.removevalidatorcss("GSTINctrl");
    }
  }
  onKeyDate(event: any) {
    const inputDate = new Date(this.addNewLR.get("date").value);
    inputDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (inputDate < yesterday || inputDate > today) {
      this.addNewLR.get("date").setValue("");
    }
    if (this.addNewLR.get("date").invalid) {
      this.addvalidatorcss("datectrl");
    } else {
      this.removevalidatorcss("datectrl");
    }
  }
  onKeyRoadPermitNo(event: any) {
    if (this.addNewLR.get("RoadPermitNo").invalid) {
      this.addvalidatorcss("RoadPermitNoctrl");
    } else {
      this.removevalidatorcss("RoadPermitNoctrl");
    }
  }
  onKeyStateCode(event: any) {
    if (this.addNewLR.get("StateCode").invalid) {
      this.addvalidatorcss("StateCodectrl");
    } else {
      this.removevalidatorcss("StateCodectrl");
    }
  }
  onKeyDLY(event: any) {
    if (this.addNewLR.get("DLY").invalid) {
      this.addvalidatorcss("DLYctrl");
    } else {
      this.removevalidatorcss("DLYctrl");
    }
  }
  onKeyDeclaredValue(event: any) {
    if (this.addNewLR.get("DeclaredValue").invalid) {
      this.addvalidatorcss("DeclaredValuectrl");
    } else {
      this.removevalidatorcss("DeclaredValuectrl");
    }
  }
  onKeytransportorName(event: any) {
    if (this.addNewLR.get("transportorName").invalid) {
      this.addvalidatorcss("transportorNamectrl");
    } else {
      this.removevalidatorcss("transportorNamectrl");
    }
  }
  onKeytransportorMobile(event: any) {
    if (this.addNewLR.get("transportorMobile").invalid) {
      this.addvalidatorcss("transportorMobilectrl");
    } else {
      this.removevalidatorcss("transportorMobilectrl");
    }
  }
  onKeyDriverName() {
    if (this.addNewLR.get("driverName").invalid) {
      this.addvalidatorcss("driverNamectrl");
    } else {
      this.removevalidatorcss("driverNamectrl");
    }
  }
  onKeyDriverMobile(event: any) {
    if (this.addNewLR.get("driverMobile").invalid) {
      this.addvalidatorcss("driverMobilectrl");
    } else {
      this.removevalidatorcss("driverMobilectrl");
    }
  }

  onKeyFrieght(event: any) {
    if (this.addNewLR.get("Frieght").invalid) {
      this.addvalidatorcss("Frieghtctrl");
    } else {
      this.removevalidatorcss("Frieghtctrl");
    }
  }

  onKeyloadingSlipAttchment(event: any) {
    if (this.addNewLR.get("loadingSlipAttchment").invalid) {
      this.addvalidatorcss("loadingSlipAttchmentctrl");
    } else {
      this.removevalidatorcss("loadingSlipAttchmentctrl");
    }
  }

  onKeyloadingSlipBackAttchment(event: any) {
    if (this.addNewLR.get("loadingSlipAttchmentBack").invalid) {
      this.addvalidatorcss("loadingSlipAttchmentBackctrl");
    } else {
      this.removevalidatorcss("loadingSlipAttchmentBackctrl");
    }
  }
  onKeyInvoiceNo(event: any) {
    if (this.addNewLR.get("InvoiceNo").invalid) {
      this.addvalidatorcss("InvoiceNoctrl");
    } else {
      this.removevalidatorcss("InvoiceNoctrl");
    }
  }
  onKeyInvoiceValue(event: any) {
    if (this.addNewLR.get("InvoiceValue").invalid) {
      this.addvalidatorcss("InvoiceValuectrl");
    } else {
      this.removevalidatorcss("InvoiceValuectrl");
    }
  }
  onKeyNoofArticle(event: any) {
    if (this.addNewLR.get("NoofArticle").invalid) {
      this.addvalidatorcss("NoofArticlectrl");
    } else {
      this.removevalidatorcss("NoofArticlectrl");
    }
  }
  onKeyFixAdhoc(event: any) {
    if (this.addNewLR.get("fixAdhoc").invalid) {
      this.addvalidatorcss("fixAdhocctrl");
    } else {
      this.removevalidatorcss("fixAdhocctrl");
    }
  }
  onKeyQuantity(event: any) {
    if (this.addNewLR.get("quantity").invalid) {
      this.addvalidatorcss("quantityctrl");
    } else {
      this.removevalidatorcss("quantityctrl");
    }
  }
  onKeyWeight(event: any) {
    if (this.addNewLR.get("Weight").invalid) {
      this.addvalidatorcss("Weightctrl");
    } else {
      this.removevalidatorcss("Weightctrl");
    }
  }
  onKeyTransportorName(event: any) {
    if (this.addNewLR.get("transportorName").invalid) {
      this.addvalidatorcss("transportorNamectrl");
    } else {
      this.removevalidatorcss("transportorNamectrl");
    }
  }
  onKeyTransportorMobile(event: any) {
    if (this.addNewLR.get("transportorMobile").invalid) {
      this.addvalidatorcss("transportorMobilectrl");
    } else {
      this.removevalidatorcss("transportorMobilectrl");
    }
  }
  onKeyCustomerName(event: any) {
    if (this.addNewLR.get("customerName").invalid) {
      this.addvalidatorcss("customerNamectrl");
    } else {
      this.removevalidatorcss("customerNamectrl");
    }
  }
  onKeyStartMeterReading(event: any) {
    if (this.addNewLR.get("startmeterReading").invalid) {
      this.addvalidatorcss("startmeterReadingctrl");
    } else {
      this.removevalidatorcss("startmeterReadingctrl");
    }
  }
  onKeyEndMeterReading(event: any) {
    if (this.addNewLR.get("endmeterReading").invalid) {
      this.addvalidatorcss("endmeterReadingctrl");
    } else {
      this.removevalidatorcss("endmeterReadingctrl");
    }
  }

  backTo() {
    window.history.back();
  }

  get InvoiceValue() {
    return this.addNewLR.get("InvoiceValue");
  }

  get Weight() {
    return this.addNewLR.get("Weight");
  }

  get NoofArticle() {
    return this.addNewLR.get("NoofArticle");
  }
  preview(index) {
    let file = this.filesToUpload[index];
    if (file) {
      if (
        ["image/jpeg", "image/png", "image/svg", "image/svg+xml"].includes(
          file.type
        )
      ) {
        const dialogRef = this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file: file },
        });
      } else {
        let url = URL.createObjectURL(file);
        this.podParticularURL = this.sanitizer.bypassSecurityTrustUrl(url);
        setTimeout(() => {
          this.showParticularPOD.nativeElement.click();
        });
      }
    } else {
      this.toastr.error("Please upload attachment");
    }
  }
  previewLR() {
    if (this.loadingSlips[0]) {
      if (
        ["image/jpeg", "image/png", "image/svg", "image/svg+xml"].includes(
          this.loadingSlips[0].type
        )
      ) {
        const dialogRef = this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file: this.loadingSlips[0] },
        });
      } else {
        let url = URL.createObjectURL(this.loadingSlips[0]);
        this.docURL = this.sanitizer.bypassSecurityTrustUrl(url);
        setTimeout(() => {
          this.showDoc.nativeElement.click();
        });
      }
    } else {
      this.toastr.error("Please upload attachment");
    }
  }

  previewLRBack() {
    if (this.loadingSlipsBack[0]) {
      if (
        ["image/jpeg", "image/png", "image/svg", "image/svg+xml"].includes(
          this.loadingSlipsBack[0].type
        )
      ) {
        const dialogRef = this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file: this.loadingSlipsBack[0] },
        });
      } else {
        let url = URL.createObjectURL(this.loadingSlipsBack[0]);
        this.docURL = this.sanitizer.bypassSecurityTrustUrl(url);
        setTimeout(() => {
          this.showDoc.nativeElement.click();
        });
      }
    } else {
      this.toastr.error("Please upload attachment");
    }
  }
  previewPOD() {
    let file = this.filesToUpload.slice(-1)[0];
    if (file) {
      if (
        ["image/jpeg", "image/png", "image/svg", "image/svg+xml"].includes(
          file.type
        )
      ) {
        const dialogRef = this.dialog.open(ImagePreviewComponent, {
          width: "80%",
          height: "90vh",
          data: { file: file },
        });
      } else {
        let url = URL.createObjectURL(file);
        this.podURL = this.sanitizer.bypassSecurityTrustUrl(url);
        setTimeout(() => {
          this.showPOD.nativeElement.click();
        });
      }
    } else {
      this.toastr.error("No file selected for Preview");
    }
  }

  checktripid(event: any) {
    if (event == "true") {
      this.check = true;
    } else {
      this.check = false;
    }
  }

  getLR() {
    this.superAdminService.getlrs().subscribe(
      (res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;

          var receiptData = [];
          for (let i = 0; i < rawdata.length; i++) {
            receiptData.push(rawdata[i].receipt);
          }

          for (let i = 0; i < receiptData.length; i++) {
            this.dropTripID.push(receiptData[i].TripID);
          }
          this.dropdownSettings = {
            singleSelection: true,
            searchPlaceholderText: "Search",
            idField: "item_id",
            textField: "item_text",
            allowSearchFilter: true,
            unSelectAllText: "UnSelect All",
          };
        } else {
          if (res.status == 401) {
            this.spinner.hide();
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl("superAuth/login");
          } else {
            this.toastr.error(res.message);
            this.spinner.hide();
          }
        }
      },
      (error) => {
        this.toastr.error("Something went wrong! Please contact us");
        this.spinner.hide();
      }
    );
  }

  getTripIDs() {
    this.superAdminService
      .getTripIDs()

      .subscribe((res: { status: any; message: any; data: any }) => {
        if (res.status == true) {
          var rawdata = res.data;
          this.tripIDS = rawdata;
          var temp = [];
          this.dropTripID.map((x) => {
            this.tripIDS.map((y) => {
              if (x == y.TripID && y.status == "running") {
                temp.push({ tripid: y.TripID });
              }

              var dropTripIDs = [];
              for (let i = 0; i < temp.length; i++) {
                dropTripIDs.push(temp[i].tripid);
              }
              this.removeDuplicates(dropTripIDs);

              this.multipletrips = this.uniqueRes;
            });
          });
        }
      });
  }

  removeDuplicates(arr) {
    let unique = [];
    arr.forEach((element) => {
      if (!unique.includes(element)) {
        unique.push(element);
      }
    });
    this.uniqueRes = unique;

    return unique;
  }

  focusonWeight(event: any) {
    var formDatas = {
      from: this.addNewLR.get("from").value,
      to: this.addNewLR.get("to").value,
      weight: this.addNewLR.get("quantity").value,
      materials: this.addNewLR.get("materials").value,
    };

    this.superAdminService.findByPlace(formDatas).subscribe((res: any) => {
      if (res.status == true) {
        let rawdata = res.data;
        this.rateChart = rawdata;
        this.materials = this.rateChart.materials;
        if (
          event.target.value <= this.rateChart[0].weight ||
          event.target.value == this.rateChart.weight
        ) {
          this.addNewLR.patchValue({
            vehicleRate: this.rateChart[0].minimum_rate,
          });
        } else if (event.target.value <= this.rateChart[1].weight) {
          this.addNewLR.patchValue({
            vehicleRate: this.rateChart[1].minimum_rate,
          });
        } else {
          this.vehicleRatees = 0;
          this.vehicleRatees = event.target.value - this.rateChart[1].weight;
          this.vehicleRatees =
            this.rateChart[1].minimum_rate +
            this.vehicleRatees * this.rateChart[1].excess_rate_per_ton;
          this.material = this.rateChart.materials;
          this.addNewLR.patchValue({
            vehicleRate: this.vehicleRatees,
          });
        }
      }
    });
  }
}
